<script setup lang="ts">
import { useExpenseTemp } from "@/store/expensesTemp";

const emit = defineEmits(["change"]);
const props = defineProps<{ ping: number }>();
const expenseTempStore = useExpenseTemp();

const items = ref({
	band: null,
	client: null,
	location: null, // ward
	category: null, // grade

	startDate: null,
	endDate: null,
	locationOfSubsistence: null,
});

const listOfBands = ref(null);
const errorArr = ref([]);

const listOfClients = computed(() => expenseTempStore.clientList);
const location = ref<any>([]); // ward
const subcategory = ref<any>([]); // grade
// new
function formatWard(item, value) {
	setItem(item, value);
	location.value = items.value.client?.locations; // locations arr which references on wards
	subcategory.value = [];
	items.value.category = null;
	items.value.location = null;

	if (location.value?.length === 1) {
		const val = generatFromVal(0);
		inputWard(val);
	}
}

function inputWard(e, manualInput = false) {
	manualInput
		? (items.value.location = e)
		: (items.value.location =
				items.value.client?.locations[Number(e.target.value)]);
	items.value.category = null;
	formatGrade(); // category

	setItem("location", items.value.location);
}

function formatGrade() {
	subcategory.value = items.value.location?.subcategories; // subcategories arr which references on grades
	items.value.category = null;
	if (subcategory.value.length === 1) {
		const val = generatFromVal(0);
		inputGrade(val, false);
	}
}
function inputGrade(e: any, manualInput = false) {
	console.log("e", e);
	manualInput
		? (items.value.category = e)
		: (items.value.category =
				items.value.location?.subcategories[Number(e.target?.value)]);

	// if (manualInput) {
	// 	items.value.category =
	// 		items.value.location?.subcategories[Number(e.target?.value)];
	// }
	//  else {
	// items.value.category = e;
	// }

	setItem("category", items.value.category);
}

function generatFromVal(i) {
	return {
		target: {
			value: i,
		},
	};
}

// end new

async function init() {
	await getBands();
}

function setItem(item, value) {
	errorArr.value.includes(item) &&
		errorArr.value.splice(errorArr.value.indexOf(item), 1);
	// items.value[item] = value;
	// console.log(`${item}: ${value}`);
	emit("change", items.value);
}

async function getBands() {
	// console.log(this.subsistanceRanges);
	const bands = expenseTempStore.getRanges("ESUB");

	listOfBands.value = bands?.map((item) => {
		return {
			from: item.from,
			to: item.to,
			id: item.id,
			value: `${item.from}${item.to ? "-" + item.to + " hours" : " hours (Overnight)"}`,
		};
	});
}

watch(
	() => props.ping,
	() => {
		errorArr.value = expenseTempStore.handleErrorPing(items.value);
	},
);
onMounted(() => {
	init();
});
</script>

<template>
	<div class="exp-form">
		<div class="group">
			<label class="label">Subsistence band*</label>
			<multiselect-form
				v-if="listOfBands"
				v-model="items.band"
				:options="listOfBands"
				label="value"
				placeholder="Subsistence band"
				value-prop="from"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('band') }"
				@select="setItem('band', $event)"
			/>
		</div>
		<div class="group">
			<label class="label">Client name*</label>
			<multiselect-form
				v-model="items.client"
				:options="listOfClients"
				label="name"
				placeholder="Choose client"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('client') }"
				@select="formatWard('client', $event)"
			/>
		</div>

		<div class="group">
			<label class="label">Ward*</label>
			<multiselect-form
				v-model="items.location"
				:options="location"
				label="name"
				placeholder="Choose ward"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('location') }"
				@select="inputWard($event, true)"
			/>
		</div>
		<div class="group">
			<label class="label">Grade*</label>
			<multiselect-form
				v-model="items.category"
				:options="subcategory"
				label="name"
				placeholder="Choose grade"
				value-prop="id"
				:multiple="false"
				:showLabels="true"
				:searchable="true"
				:class="{ error: errorArr.includes('category') }"
				@select="inputGrade($event, true)"
			/>
		</div>

		<div class="group">
			<modern-input
				ref="number"
				v-model="items.locationOfSubsistence"
				label="Location of subsistence*"
				:bind="{
					placeholder: 'Input text...',
					class: { error: errorArr.includes('locationOfSubsistence') },
				}"
				type="number"
				@change="setItem('locationOfSubsistence', $event)"
			></modern-input>
		</div>
		<div class="group">
			<label class="label">Start date/time of subsistence*</label>
			<modern-date-picker
				v-model="items.startDate"
				placeholder="Start Date/Time"
				:clearable="false"
				:enable-time-picker="true"
				format="dd/MM/yyyy, HH:mm"
				outputFormatString="YYYY-MM-DD HH:mm:ss"
				:class="{ error: errorArr.includes('startDate') }"
				@update:model-value="setItem('startDate', $event)"
			/>
		</div>
		<div class="group">
			<label class="label">End date of subsistence*</label>
			<modern-date-picker
				v-model="items.endDate"
				placeholder="End Date/Time"
				:clearable="false"
				:enable-time-picker="true"
				format="dd/MM/yyyy, HH:mm"
				outputFormatString="YYYY-MM-DD HH:mm:ss"
				:class="{ error: errorArr.includes('endDate') }"
				@update:model-value="setItem('endDate', $event)"
			/>
		</div>
	</div>
</template>

<style lang="scss">
.exp-form {
	.error {
		border-color: $error-color !important;
	}
	label.label {
		color: $label-accent-color;
		font-size: 0.8rem;
		min-width: 100px;
		user-select: none;
	}
	.modern-input {
		padding: 0 !important;
	}
}
</style>
